import DataObjectField from "@/utilities/classes/data-object-field";

const buildApplicationSubmitDataObject = (vData) => {
  const fields = [
    new DataObjectField(vData.Tenant.FirstName, 156),
    new DataObjectField(vData.Tenant.LastName, 157),
    new DataObjectField(vData.Tenant.Email, 166),
    new DataObjectField(vData.Landlord.ActiveLandlord, 174),
    new DataObjectField(vData.Landlord.FirstName, 168),
    new DataObjectField(vData.Landlord.LastName, 169),
    new DataObjectField(vData.Landlord.CompanyName, 170),
    new DataObjectField(vData.Landlord.Email, 171),
    new DataObjectField(vData.Confirm.Signature, 362),
    new DataObjectField(vData.Confirm.Date, 363),
    new DataObjectField(13, 121),
    new DataObjectField(new Date(), 155),
    new DataObjectField((vData.Landlord.ActiveLandlord == "No") ? null : new Date(), 233),
    new DataObjectField(true, 232),
    new DataObjectField(3, 275),
  ];

  const dataObject = {
    qdbapi: {
      udata: "COMMON_APP_SUBMIT",
      field: fields
    }
  };
  return dataObject;
};

export default buildApplicationSubmitDataObject;